import { SearchableStringFilterInput } from 'generated-graphql/types';

export const buildTextSearchClauses = <TField extends string>(
  field: TField,
  searchText: string
): Record<TField, SearchableStringFilterInput>[] =>
  [
    { [field]: { matchPhrasePrefix: searchText } },
    { [field]: { wildcard: `*${searchText.toLowerCase()}*` } }
  ] as Record<TField, SearchableStringFilterInput>[];
